import { ColoredTextBoxContentModel } from 'src/api/models/ColoredTextBox';
import styled from 'styled-components';
import { cssVar } from 'styles/helper';

// TODO: Once Contentful is updated, remove the legacy color support
const getBackgroundColor = (backgroundColor: ColoredTextBoxContentModel['backgroundColor']) => {
  if (backgroundColor === 'black') return cssVar('bg-primary-solid');
  if (backgroundColor === 'white') return cssVar('bg-primary');
  if (backgroundColor === 'bg-primary-solid') return cssVar('bg-primary-solid');
  if (backgroundColor === 'bg-primary') return cssVar('bg-primary');
  // All Other should fallback to branded colors
  return cssVar('bg-brand-primary');
};

const getBackgroundTextColor = (backgroundColor: ColoredTextBoxContentModel['backgroundColor']) => {
  if (backgroundColor === 'black') return cssVar('text-primary-on-brand');
  if (backgroundColor === 'white') return cssVar('text-primary');
  if (backgroundColor === 'bg-primary-solid') return cssVar('text-primary-on-brand');
  if (backgroundColor === 'bg-primary') return cssVar('text-primary');
  return cssVar('text-primary');
};

export const ColoredTextBoxContainer = styled.div<{ backgroundColor: ColoredTextBoxContentModel['backgroundColor'] }>`
  padding: 3rem;
  margin: 2rem 0;
  border-radius: 1rem;
  background-color: ${({ backgroundColor }) => getBackgroundColor(backgroundColor)};
  color: ${({ backgroundColor }) => getBackgroundTextColor(backgroundColor)};

  h5.ast-h5-element {
    padding-top: 0;
  }

  p.ast-p-element {
    margin: 1rem 0em;
  }

  a.ast-a-element {
    color: ${({ backgroundColor }) => getBackgroundTextColor(backgroundColor)} !important;
  }
`;
